import React from 'react';
import { Box, alpha, useTheme } from '@mui/material';
import AmbientBackground from '../AmbientBackground';
import LogoLoader from './LogoLoader';
import usePageTransition from './usePageTransition';

const PageTransitionLoader = () => {
	const theme = useTheme();
	const { isVisible, isFadingOut } = usePageTransition();

	if (!isVisible) {
		return null;
	}

	return (
		<Box
			aria-live="polite"
			aria-busy="true"
			sx={{
				position: 'fixed',
				inset: 0,
				zIndex: (t) => t.zIndex.modal + 2,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				overflow: 'hidden',
				opacity: isFadingOut ? 0 : 1,
				transition: theme.transitions.create('opacity', {
					duration: 320,
					easing: theme.transitions.easing.easeInOut,
				}),
				pointerEvents: isFadingOut ? 'none' : 'auto',
			}}
		>
			<Box sx={{ position: 'absolute', inset: 0 }}>
				<AmbientBackground />
			</Box>

			<Box
				sx={{
					position: 'absolute',
					inset: 0,
					bgcolor: alpha(
						theme.palette.mode === 'dark' ? '#000000' : '#F2F2F7',
						0.55,
					),
					backdropFilter: 'blur(24px) saturate(150%)',
					WebkitBackdropFilter: 'blur(24px) saturate(150%)',
				}}
			/>

			<Box
				sx={{
					position: 'relative',
					zIndex: 1,
					transform: isFadingOut ? 'scale(0.92) translateY(8px)' : 'scale(1) translateY(0)',
					opacity: isFadingOut ? 0 : 1,
					transition: theme.transitions.create(['opacity', 'transform'], {
						duration: 320,
						easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
					}),
				}}
			>
				<LogoLoader />
			</Box>
		</Box>
	);
};

export { LogoLoader };
export default PageTransitionLoader;
